// extracted by mini-css-extract-plugin
export default {"customtable":"Modal_customtable__WTsA0"};